module.exports = __webpack_public_path__ + "images/assets/bb51dd164f6adac8cda8a750832912fc.svg";